var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"btn",class:{'active':_vm.item.star}},[_c('div',{staticClass:"icon",on:{"click":_vm.click}}),_c('span',{on:{"click":_vm.txtClick}},[_vm._v(_vm._s(_vm.txt))])])
}
var staticRenderFns = []

export { render, staticRenderFns }